import React, { useContext, useEffect, useMemo, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import Input from "../../../../../stories/Input/Input";
import { TextField } from "@mui/material";
import Compare from "../../../../../images/Compare.svg";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid-pro";
import { TableHeaderProps } from "../../../../../utils/types";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/Delete.svg";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import Modal from "react-modal";
import {
  ViewModalStyles,
  WaiveOffModalStyles,
} from "../../../../../styles/CustomModalStyles";
import Confirmation from "./confirmation/Confirmation";
import Send from "../../../../../images/Send.svg";
import View from "./View";
import Mail from "../../../../../images/Mail.svg";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetRfqs } from "./queries/queries";
import {
  AtsRfqMstEdge,
  AtsRfqMstOrderField,
  DeleteRfqResult,
  DeleteRfqVar,
  GetRfqsResult,
  GetRfqsVars,
  RfqQueryType,
  SendEmailToSuppliersResult,
  SendEmailToSuppliersVars,
} from "./queries/types";

import { AppContext } from "../../../../../context/context";
import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../utils/constants";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import {
  getModifiedScrollHeight,
  toInputStandardDate,
  toIsoDate,
  toStandardDate,
} from "../../../../../utils/UtilFunctions";
import useServerDateandTime from "../../../../../customHooks/useServerDateandTime";
import { DeleteRfq, SendEmailToSuppliers } from "./queries/mutations";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { LicenseTypes, Operation } from "../../../../../utils/Enum.types";
import MessageModal from "../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../pages/LoadingModal";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import Navbar from "../../../../common/layout/Navbar";
import { useHotKey } from "../../../../../utils/hotKeys";
import { SpecialKeys } from "../../../../../utils/Enum.keys";

interface formDates {
  startDate: string;
  endDate: string;
}

export interface confirmationType {
  rfqId: number;
  flag: boolean;
}
const QuotationList = () => {
  const navigate = useNavigate();
  const { customer_id, company_id } = useUrlParams();
  const { Purchase } = useAssetTableJson();
  const [deleteModal, setDeleteModal] = useState(false);
  const [confirmation, setConfirmation] = useState<confirmationType>({
    rfqId: 0,
    flag: false,
  });
  const [viewModal, setViewModal] = useState(false);
  const [rfqs, setRfqs] = useState<AtsRfqMstEdge[]>([]);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [rfqId, setRfqId] = useState(0);
  const [message, setMessage] = useState(emptyMessage);

  const { data: todaysDateData, serverDate } = useServerDateandTime();

  const [dates, setDates] = useState<formDates>({
    startDate: "",
    endDate: "",
  });

  const { state } = useContext(AppContext);

  
  const { user_details } = useLoggedInUserDetails();

  const [GetRFQ, { loading, data, fetchMore }] = useLazyQuery<
    GetRfqsResult,
    GetRfqsVars
  >(GetRfqs);

  const [SendMail] = useMutation<
    SendEmailToSuppliersResult,
    SendEmailToSuppliersVars
  >(SendEmailToSuppliers, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [DeleteRfqById, { loading: DeleteRfqLoading }] = useMutation<
    DeleteRfqResult,
    DeleteRfqVar
  >(DeleteRfq, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.DELETE,
      });
    },
  });

  const dynamicHeaders: TableHeaderProps[] = Purchase.Quotation.List.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      cellClassName: header.cellClassName,
      hideable: header.hideable,
      renderCell: (params) => {
        if (header.field === "mail_status") {
          return (
            <div>
              {params.row.mail_status === "sent" ? (
                <>
                  <img
                    src={Mail}
                    alt=""
                    className="quotation__tableblock--mail-status"
                  />{" "}
                  Sent
                </>
              ) : (
                <button
                  className="quotation__tableblock--send-mail"
                  onClick={() =>
                    setConfirmation({
                      flag: true,
                      rfqId: params.row.rfqId,
                    })
                  }
                >
                  Send Mail <img src={Send} alt="" />
                </button>
              )}
            </div>
          );
        }
        if (header.field === "actions") {
          return (
            <>
              <img
                src={Edit}
                alt=""
                onClick={() =>
                  navigate(
                    `/${customer_id}/company/${company_id}/purchase/quotation/${params.row.rfqId}/edit`
                  )
                }
              />
              <img
                src={Delete}
                alt=""
                onClick={() => {
                  setRfqId(params.row.rfqId);
                  setDeleteModal(!deleteModal);
                }}
              />
            </>
          );
        }
        return params.value;
      },
    })
  );
  const columns: GridColDef[] = [...dynamicHeaders];

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetRfqs.edges;
              const pageInfo = fetchMoreResult.GetRfqs.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetRfqs.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetRfqs: {
                  edges: [...rfqs, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetRfqs.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rfqs.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rfqs]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetRfqs.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = rfqs.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setRfqs(updatedNewData);
      } else {
        setRfqs(newData);
      }
      setEndCursor(data.GetRfqs.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    if (customer_id && state.ActiveFinYr) {
      GetRFQ({
        variables: {
         
          after: null,
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          first: ROWS_PER_PAGE,
          name: EMPTY_STRING,
          end_date: toIsoDate(dates.endDate),
          start_date: toIsoDate(dates.startDate),
          queryType: RfqQueryType.ALL,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsRfqMstOrderField.RFQ_DATE,
          },
        },
      });
    }
  }, [customer_id, state.ActiveFinYr, GetRFQ, dates.endDate, dates.startDate]);

  const rowsData = useMemo(() => {
    return rfqs.map((rfq, index) => ({
      id: index + 1,
      rfq_date: toStandardDate(rfq.node.rfqDate),
      request_for_quotation_no: rfq.node.rfqNo,
      total_items_quoted: 10,
      approx_value: 10,
      late_date_for_submission: "01-11-2024",
      rfq_prepared_by: "fghj",
      rfq_authorized_by: "iuyt",
      remarks: "remarks",
      mail_status: false,
      rfqId: rfq.node.id,
    }));
  }, [rfqs]);

  useEffect(() => {
    if (todaysDateData && serverDate) {
      const getMonth = new Date(serverDate).getMonth();
      const getYear = new Date(serverDate).getFullYear();

      const firstDay = new Date(getYear, getMonth, 1); // First day of the month
      const lastDay = new Date(getYear, getMonth + 1, 0);

      setDates({
        endDate: lastDay.toString(),
        startDate: firstDay.toString(),
      });
    }
  }, [todaysDateData, serverDate]);
  const HandleDelete = async () => {
    setDeleteModal(!deleteModal);
     
      if (customer_id && rfqId && state.ActiveFinYr) {
        DeleteRfqById({
          variables: {
            
            customerId: customer_id,
            finYrId: state.ActiveFinYr.id,
            rfqId: rfqId,
            user_details,
          },
          refetchQueries: [
            {
              query: GetRfqs,
              variables: {
                
                after: null,
                customerId: customer_id,
                finYrId: state.ActiveFinYr.id,
                first: ROWS_PER_PAGE,
                name: EMPTY_STRING,
                queryType: RfqQueryType.ALL,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsRfqMstOrderField.RFQ_DATE,
                },
              },
            },
          ],
        }).then(({ data }) => {
          if (data) {
            setMessage({
              flag: true,
              message: "Deleted successfully",
              operation: Operation.DELETE,
            });
          }
        });
      }
  };

  const handleSendMail = async () => {
    if (customer_id && state.ActiveFinYr)
      SendMail({
        variables: {
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          rfqId: confirmation.rfqId,
          
          user_details,
        },
      }).then(({ data }) => {
        if (data && data.SendEmailToSuppliers) {
          setMessage({
            flag: true,
            message: "Sent mail successfully",
            operation: Operation.CREATE,
          });
          setConfirmation({
            flag: false,
            rfqId: 0,
          });
        }
      });
  };
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.REQUEST_FOR_QUOTATION
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.REQUEST_FOR_QUOTATION,
      JSON.stringify(newModel)
    );
  };

  //hot key for addition ctrl+a
  useHotKey({
    handleFunc: () => {
      navigate(`/assets/purchase/${customer_id}/quotation/add`);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />
      <Title>Request for Quotation</Title>
      <div className="quotation">
        <div className="quotation__select row g-0">
          <div className="col-2">
            <Input id="data_search" placeholder="Search..." />
          </div>
          <div className="col">
            <div className="quotation__select--flex">
              <TextField
                type="date"
                label="Start Date"
                className="quotation__select--textfield"
                value={toInputStandardDate(dates.startDate)}
                onChange={(e) => {
                  setDates({
                    ...dates,
                    startDate: e.target.value,
                  });
                }}
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
              />
              <img src={Compare} alt="" />
              <TextField
                type="date"
                label="End Date"
                className="quotation__select--textfield"
                value={toInputStandardDate(dates.endDate)}
                onChange={(e) => {
                  setDates({
                    ...dates,
                    endDate: e.target.value,
                  });
                }}
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
              />
            </div>
          </div>
          <div className="col-1 flex-end">
            <Button
              mode="addnew"
              onClick={() =>
                navigate(
                  `/${customer_id}/company/${company_id}/purchase/quotation/add`
                )
              }
            />
          </div>
        </div>
        <div className="quotation__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rowsData}
            rowHeight={TABLE_ROW_HEIGHT}
            onCellClick={(params) => {
              if (params.field === "request_for_quotation_no") {
                setViewModal(!viewModal);
              }
            }}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel,
              },
            }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>

      <DeleteModal
        id={0}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />
      <Modal
        isOpen={confirmation.flag}
        style={WaiveOffModalStyles}
        ariaHideApp={false}
      >
        <Confirmation
          setModalFlag={setConfirmation}
          handleSendMail={handleSendMail}
        />
      </Modal>

      <Modal isOpen={viewModal} style={ViewModalStyles} ariaHideApp={false}>
        <View setModalFlag={setViewModal} />
      </Modal>
      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />

      <LoadingModal flag={loading || DeleteRfqLoading} />
    </>
  );
};

export default QuotationList;
